// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"135":"402f2364","227":"8aa3a008","236":"d91b7233","291":"90d3d221","295":"0d10c4c6","343":"bff64d0b","380":"2a11a592","456":"f59cbe9f","495":"8bb43d90","549":"85cc9bb7","571":"3fe1fdee","582":"f8bbd912","719":"2a580960","774":"6c30afe2","792":"423fc858","931":"e2e4d391"}[chunkId] + ".js";
};